import { unwrapConfigKey } from "../interfaces/ReplicatedObject";
export class Game {
    constructor(stage, replicatedObjects, replicatedActions, replicatedTimeouts) {
        this.replicatedActionClient = null;
        this.stage = stage;
        const replicatedObjectConfigMap = Object.create(null);
        replicatedObjects.forEach((obj) => replicatedObjectConfigMap[obj.className] = obj);
        const replicatedObjectKeyMapping = (input, data) => replicatedObjectConfigMap[data.className].getMappedKey(input, data);
        const allReplicatedObjectKeys = replicatedObjects.flatMap((obj) => obj.configKeys)
            .map((configKey) => unwrapConfigKey(configKey));
        const requiredReplicatedObjectKeys = replicatedObjects.flatMap((obj) => obj.configKeys)
            .filter((configKey) => 'required' in configKey).map((configKey) => configKey.required);
        const replicatedObjectViewBuilderMap = Object.create(null);
        replicatedObjects.forEach((obj) => replicatedObjectViewBuilderMap[obj.className] = obj.view);
        const writeableReplicatedObjectBuilderMap = Object.create(null);
        replicatedObjects.forEach((obj) => writeableReplicatedObjectBuilderMap[obj.className] = obj.writer);
        const actionValidatorMap = Object.create(null);
        replicatedActions.forEach((act) => actionValidatorMap[act.className] = act.validator);
        const actionEffectMap = Object.create(null);
        replicatedActions.forEach((act) => actionEffectMap[act.className] = act.effect);
        const replicatedTimeoutBuilderMap = Object.create(null);
        replicatedTimeouts.forEach((tim) => replicatedTimeoutBuilderMap[tim.className] = tim.replicatedTimeout);
        const gameContextListenerKeys = ['gameId', 'gameInitialized', 'gameLifecycleStage', 'host', 'lastGameSummary', 'playerId'];
        gameContextListenerKeys.push(...allReplicatedObjectKeys);
        this.clientConfig = {
            gameContextListenerKeys,
            actionValidatorMap,
            requiredReplicatedObjectKeys,
            replicatedObjectKeyMapping,
            replicatedObjectViewBuilderMap,
        };
        this.serverConfig = {
            writeableReplicatedObjectBuilderMap,
            actionValidatorMap,
            actionEffectMap,
            replicatedTimeoutBuilderMap,
            replicatedObjectKeyMapping,
            replicatedObjectViewBuilderMap,
            requiredReplicatedObjectKeys,
            onInitializeGame: (createReplicatedObject) => this.onInitializeGame(createReplicatedObject),
            onCommitEndGame: (getWriterContext) => this.onCommitEndGame(getWriterContext),
            getPlayerRecordInput: () => this.getPlayerRecordInput(),
        };
    }
}
//# sourceMappingURL=Game.js.map